module.exports = __webpack_public_path__ + "img/13a)Arabella Sheraton Hotel in München.jpg";